import React, { memo } from "react";
import P1DailyTable from "./P1DailyTable";
import POverallChart from "./POverallChart";
import PWeeklyChart from "./PWeeklyChart";
import P2DailyTable from "./P2DailyTable";

const StaticChart = ({type}) => {
  
  return (
    <div className="pt-0 space-y-5 px-4">
      {/* <div className="flex"> */}
      <div className="w-full block">
        <PWeeklyChart type={type} />
      </div>
      {/* 
        <div className="w-1/2 flex-shrink-0">
          <P2WeeklyChart />
        </div>
         */}
      {/* </div> */}
      <div className="flex space-x-2">
        <div className="w-full">
          {type === "P1" ? <P1DailyTable /> : <P2DailyTable />}
        </div>
        {/* <div className="w-1/2 flex-shrink-0">
          <P2DailyTable />
        </div> */}
      </div>
      {/* <div className="flex"> */}
      <div className="w-full block">
        <POverallChart type={type} />
      </div>
      {/* 
        <div className="w-1/2 flex-shrink-0">
          <P2OverallChart />
        </div>
         */}
      {/* </div> */}
    </div>
  );
};

export default memo(StaticChart);
